import React from "react";
import Data from "../../assets/data/data";

const FoodMenu = ({ activeSection }) => {
  const barData = Data.find((val) => val.id === 5);

  const renderFoodMenu = () => (
    <div className="grid grid-cols-1 gap-3 lg:px-48 lg:py-16">
      {barData.foodItems.map((item, id) => {
        return (
          <div key={id}>
            <img src={item.image} alt="id" className="w-full" />
          </div>
        );
      })}
    </div>
  );

  if (!activeSection) {
    return <div>{renderFoodMenu()}</div>;
  }

  return <div>{activeSection === "food" && renderFoodMenu()}</div>;
};

export default FoodMenu;
